
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.155 3.488l2.357 2.357m-1.357-3.357a1.667 1.667 0 112.357 2.357l-9.179 9.179H2v-2.381l9.155-9.155z","stroke":"gray","stroke-width":".889","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    